/** 只处理当前已加载项；权限以服务端能力为准，未加载页不会被暗中选中。 */
export function setLoadedClueSelection(rows, canReview, selected) {
  rows.forEach((row) => { row.selected = canReview && Boolean(selected); });
  return rows.filter((row) => row.selected);
}

/** 表头全选和半选状态，追加新页后仍准确反映当前已加载集合。 */
export function loadedClueSelectionState(rows) {
  const count = rows.filter((row) => row.selected).length;
  return { all: rows.length > 0 && count === rows.length, partial: count > 0 && count < rows.length };
}
